<template>
  <div class="d-flex flex-column" >
    <div class="d-flex flex-column flex-root align-items-stretch h-100">
      <div
        class="bg-white py-10"
        style="position: fixed; top: 0; left: 0; right: 0; z-index: 1000; width: 100%; border-bottom-right-radius: 1.5rem; border-bottom-left-radius: 1.5rem;">
      </div>

      <div :style="backgroundStyle" class="page d-flex flex-row align-items-stretch flex-column-fluid py-20 background-container" style="overflow-y: auto; flex: 1 1 auto; padding-right: 1rem;" >
        <div class="ms-8 center_vertical">
          <div class="p-3 bg-white img_top d-flex justify-content-center align-items-center">
            <img :src="eventValue?.logo ? eventValue?.logo : '/assets/media/icon-event.png'"/>
          </div>
          <h1 class="text-white text-uppercase h1_style">{{ eventValue.title }}</h1>
          <p ref="descriptionRef" class="text-white p_style" :class="{'truncate-text': isTruncated}" v-html="eventValue.description"></p>
          <div class="d-flex justify-content-end span_style" >
            <span class="text-white fs-4" style="text-decoration: underline;" @click="toggleText">{{ viewMoreText }}</span>
          </div>
          <div class="mt-5 text-white address">
            <div class="d-flex me-10 fs-18 mb-5">
              <i class="fa fa-calendar me-5 mt-2 text-white fs-18"></i> 
              <span class="fw-bolder">
                {{ firstDate?.toLocaleDateString(locale, {
                  year: 'numeric', month: 'numeric', day: 'numeric',
                  hour: 'numeric', minute: 'numeric'
                }) }}
              </span>
            </div>
            <div class="d-flex fs-18">
              <i class="fa fa-map-marker me-5 mt-2 text-white fs-18"></i> 
              <span class="fw-bolder">{{ eventValue.place }}</span>
            </div>
          </div>

          <div class="mt-5 d-flex text-white timer">
            <span class="me-5 single-digit italic-text">
              <span class="time-number">{{ time.days }}</span>
              <span class="time-label">{{ $t('events.days') }}</span>
            </span>
            <span class="me-5 single-digit italic-text">
              <span class="time-number">{{ time.hours }}</span>
              <span class="time-label">{{ $t('events.hours') }}</span>
            </span>
            <span class="me-5 single-digit italic-text">
              <span class="time-number">{{ time.minutes }}</span>
              <span class="time-label">{{ $t('events.minutes') }}</span>
            </span>
            <span class="me-5 single-digit italic-text">
              <span class="time-number">{{ time.seconds }}</span>
              <span class="time-label">{{ $t('events.seconds') }}</span>
            </span>
          </div>

          <div class="d-flex text-white" v-if="eventValue.forms?.length > 0">
            <a @click="chooseTypeForRegister" class="btn btn-primary italic-text text-white fs-18 mb-10">
              {{ $t('events.do_register') }}
            </a>
          </div>
        </div>
      </div>

      <div class="chat_fixed" @click="showForm = !showForm">
        <i class="fa fa-comment"
          :class="showForm ? 'text-primary' : 'text-white'"
          style="font-size: 30px !important;"></i>
      </div>

      <div class="form_fixed card shadow-sm p-5" v-if="showForm">
        <h1 class="text-center mb-5">{{ $t('events.the_questions') }}</h1>
        <Input
          container-class="col-12 form-group mb-5"
          :name="`fullname`"
          type="text"
          :inputClass="'form-control form-control-lg form-control-solid'"
          size="lg"
          :isRequired="true" 
          :placeholder="$t('events.fullname')"
          v-model="formQuestion.name"
        />
        <Input
          container-class="col-12 form-group mb-5"
          :name="`email`"
          type="email"
          :inputClass="'form-control form-control-lg form-control-solid'"
          size="lg"
          :isRequired="true" 
          :placeholder="$t('events.email')"
          v-model="formQuestion.email"
        />
        <textarea
          class="form-control form-control-lg form-control-solid mb-5"
          :placeholder="$t('events.message')"
          rows="6"
          v-model="formQuestion.message"
        ></textarea>
        <Button btn-class="btn-md" type="new" btn-text="button.send" @click="submitQuestion" :is-loading="isLoadingQuestion"></Button>
      </div>

      <div class="footer bg-white py-7" id="kt_footer" style="position: fixed; bottom: 0; left: 0; right: 0; z-index: 1000; width: 100%;">
        <div class="container-fluid d-flex flex-column flex-md-row align-items-center justify-content-center">
          <div class="text-dark order-2 order-md-1 fs-2">
            <span>{{ $t('powered') }}
              <a class="text-hover-primary" target="_blank" href="https://netbyus.com">{{ $t('poweredby') }}</a>
            </span>
            <span class="px-2">©{{ new Date().getFullYear() }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
  import Button from "@/components/Button";
  import Input from "@/components/Input.vue";
  import { ref, onMounted, watch, computed } from "vue"; 
  import { useTimer } from 'vue-timer-hook';
  import {useStore} from "vuex";
  import {useRoute, useRouter} from "vue-router";
  import {useLocales} from "@/composables/locales";

  const store = useStore()
  const route = useRoute()
  const router = useRouter()
  const {locale} = useLocales()

  const showForm = ref(false)
  const eventValue = ref({})
  const dates = ref([])
  const firstDate = ref(null)
  const isLoadingQuestion = ref(false)
  const isTruncated = ref(true)
  const descriptionRef = ref(null);

  const time = computed(() => useTimer(firstDate.value))
  const backgroundStyle = computed(() => ({
    backgroundImage: eventValue.value?.banner
      ? `url('${eventValue.value.banner}')`
      : `url('/assets/media/register1.png')`,
    backgroundSize: 'cover',
    backgroundPosition: 'center',
    backgroundAttachment: 'fixed',
    width: '100%',
    minHeight: '100vh',
    position: 'relative',
    zIndex: 0
  }))
  const viewMoreText = computed(() => {
    return isTruncated.value ? i18n.global.t('events.view_more') : i18n.global.t('events.view_less')
  })

  const formQuestion = ref({
    name: "",
    email: "",
    message: ""  
  })

  watch(() => dates.value, (value) => {
    if(value){
      const today = new Date();
      firstDate.value = value
        .map(date => new Date(date))
        .filter(date => date > today)
        .sort((a, b) => a - b)[0];
    }
  }, { deep: true });

  function toggleText() {
    isTruncated.value = !isTruncated.value ;
  }

  async function showEvent() {
      await store.dispatch('events/getEventDetailForParticipator', route.params.id).then((res) => {
        eventValue.value = res.data?.data
        dates.value = eventValue.value?.dates?.map(date => date.day + ' ' + date.start);
      })
  }

  function chooseTypeForRegister() {
    if(eventValue.value.forms?.length > 0){
      router.push({name: 'event-participator-register', params: {id: route.params.id}})
    }
  }

  function submitQuestion() {
    isLoadingQuestion.value = true
    store
        .dispatch('forms/sendContact', formQuestion.value)
        .then(() => {
          showForm.value = false
          window.toastr["success"](i18n.global.t('events.sended_successfully'));
        })
        .catch((e) => {
        }).finally(() => isLoadingQuestion.value = false);
  }

  onMounted(() => {
    showEvent()
  })
</script>

<style scoped>
  .center_vertical {
    width: 80%;
    margin: 0 auto !important;
    padding-top: 3rem;
  }

  .chat_fixed {
    position: fixed;
    right: 2rem;
    bottom: 7rem;
    cursor: pointer !important;
  }

  .form_fixed {
    position: fixed;
    right: 2rem;
    bottom: 11rem;
    width: 300px; 
    height: 350px;
  }

  .italic-text {
    font-style: italic;
  }

  .btn.btn-orange {
    color: #fff;
    border-color: var(--bs-warning) !important;
    background-color: var(--bs-warning) !important;
  }

  .single-digit {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    font-size: 50px;
    background-color: rgba(0, 33, 119, 0.3);
    border-radius: 5px;
    padding: 10px;
    color: #fff;
    min-width: 90px !important;
    height: 100px !important;
    position: relative;
  }

  .time-label {
    font-size: 12px !important;
    line-height: 1;
    margin-top: 5px;
    font-weight: 500;
  }

  .time-number {
    font-size: 50px !important;
    line-height: 1;
    font-weight: 500;
  }

  .h1_style {
    font-size: 75px !important; 
    margin-bottom: 2rem;
  }

  .p_style {
    font-size: 20px !important; 
    width: 90% !important;
  }

  .span_style {
    font-size: 10px !important; 
    width: 88% !important;
    margin-bottom: 2rem; 
    cursor: pointer;
    margin-right: 5rem !important;
  }

  .timer {
    width: 200px !important; 
    margin-bottom: 8rem;
  }

  .fs-18 {
    font-size: 18px !important;
  }

  .address {
    margin-bottom: 3rem; 
    display: flex;
  }

  .img_top {
    width: 60px; 
    height: 60px; 
    border-radius: 1rem; 
    margin-bottom: 2rem;
  }

  .img_top img {
    width: 42px;
  }

  .truncate-text {
    display: -webkit-box;
    -webkit-line-clamp: 5;
    -webkit-box-orient: vertical;
    overflow: hidden;
  }

  .background-container {
    position: relative;
    width: 100%;
    min-height: 100vh;
  }

  .background-container::after {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 33, 119, 0.45);
    z-index: 0;
  }

  .background-container > * {
    position: relative;
    z-index: 1;
  }

  @media (max-width: 768px) {
    .center_vertical {
      padding-top: 1.5rem !important;
    }

    .h1_style {
      font-size: 30px !important; 
    }

    .p_style {
      font-size: 15px !important;
      width: 100% !important;
    }

    .span_style {
      font-size: 10px !important; 
      width: 100% !important;
    }

    .timer {
      width: 100px !important; 
    }

    .single-digit {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      font-size: 20px;
      background-color: rgba(0, 33, 119, 0.3);
      border-radius: 5px;
      padding: 5px;
      color: #fff;
      min-width: 60px !important;
      height: 80px !important;
      position: relative;
    }

    .time-label {
      font-size: 9px !important;
      line-height: 1;
      margin-top: 5px;
    }

    .time-number {
      font-size: 30px !important;
      line-height: 1;
    }

    .fs-18 {
      font-size: 12px !important;
    }

    .address {
      display: block;
    }

    .address .fs-18 {
      font-size: 15px !important;
    }

    .img_top {
      width: 40px; 
      height: 40px; 
      border-radius: 1rem; 
      margin-bottom: 5rem;
    }

    .img_top img {
      width: 25px;
    }
  }
</style>